module.exports = __webpack_public_path__ + "static/media/google-2-read-qr.c860b566.png";